import React from 'react';
import { useIntl } from 'react-intl';
import OptionsButton from '../../../../global/options-button/options-button';
import { showNotification } from '../../../../global/modal/alerts-host/alert-templates';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';
import { ConnectionType, IConnectionDetailsDTO } from '../../../../../api/connections.dao';
import { CONFIGURE_PASSPORT_DISPLAY_TEXT, DELETE_TEXT, MORE_BUTTON_TEXT } from '../../../../../constants/common-labels.constants';
import { PASSPORT_CONFIGURATION_CONNECTIONS } from '../configure-passport-display/configure-passport-display.config';
import { ConnectionVersion } from '../../../../../constants/common.constants';

export interface IProps {
    connection: IConnectionDetailsDTO;
    handleOnChange: (connection: IConnectionDetailsDTO) => void;
    showConfigurePassportForm: (connection: IConnectionDetailsDTO) => void;
    setDeletePopoverConnection: (connection: IConnectionDetailsDTO | null) => void;
    isPopoverOpen: boolean;
    setIsPopoverOpen: (isPopoverOpen: boolean) => void;
    cloneConnection: (connection: IConnectionDetailsDTO) => void;
    shouldDisableDeleteButton: boolean;
    knovioPreCheckLoading?: boolean;
}

const ConnectionDetailsPopoverOptionsButton = (props: IProps) => {
    const intl = useIntl();

    const {
        connection,
        handleOnChange,
        showConfigurePassportForm,
        setDeletePopoverConnection,
        isPopoverOpen,
        setIsPopoverOpen,
        cloneConnection,
        shouldDisableDeleteButton,
        knovioPreCheckLoading
    } = props;

    const connectionManagementPermission = hasPermission(Permission.CONNECTIONS_MANAGEMENT);
    const knovioPreCheckIsRequired = hasPermission(Permission.EDIT_KNOVIO_LIVE_STREAMS) && connection.type === ConnectionType.Knovio;
    const isEditButtonDisabled = knovioPreCheckIsRequired ? knovioPreCheckLoading && connection.cancelled : connection.cancelled;
    const isPassportDisplayConnection = PASSPORT_CONFIGURATION_CONNECTIONS.includes(connection.type);
    const isV2PanelistChild = connection.connectionVersion === ConnectionVersion.V2 && connection.type === ConnectionType.PanelistLink;

    const meetingOptionsButton = [
        connectionManagementPermission && {
            label: intl.formatMessage({
                id: `oe.connectionDetailsPopover.Edit`,
                description: 'Label text',
                defaultMessage: 'Edit',
            }),
            action: () => {
                handleOnChange(connection);
                setIsPopoverOpen(!isPopoverOpen);
            },
            disabled: isEditButtonDisabled
        },
        isPassportDisplayConnection && {
            label: intl.formatMessage(CONFIGURE_PASSPORT_DISPLAY_TEXT),
            action: () => {
                showConfigurePassportForm(connection);
                setIsPopoverOpen(!isPopoverOpen);
            },
            disabled: connection.cancelled
        },
        !isV2PanelistChild && {
            label: intl.formatMessage({
                id: `oe.connectionDetailsPopover.CloneAll`,
                description: 'Label text',
                defaultMessage: 'Clone',
            }),
            action: () => {
                cloneConnection(connection);
                navigator.clipboard.writeText(`${JSON.stringify(connection)}`);
                showNotification(intl.formatMessage({
                    id: 'oe.connectionDetailsPopover.clonedConnectionDetails',
                    defaultMessage: 'Cloned Connection Details',
                    description: 'Notification message',
                }));
                setIsPopoverOpen(!isPopoverOpen);
            },
            disabled: connection.cancelled
        },
        setDeletePopoverConnection && connectionManagementPermission && {
            label: intl.formatMessage(DELETE_TEXT),
            action: () => {
                if (isPopoverOpen) props.setIsPopoverOpen(false);
                setDeletePopoverConnection(connection);
            },
            danger: true,
            disabled: shouldDisableDeleteButton
        }
    ].filter(Boolean);

    return meetingOptionsButton.length
        ? (<OptionsButton
            className='small-button'
            label={intl.formatMessage(MORE_BUTTON_TEXT)}
            options={meetingOptionsButton}
            position='top'
            align='start'
        />)
        : null;
};

export { ConnectionDetailsPopoverOptionsButton };
